import { apiPaths, queryKeyWithNpsn } from 'api/kinerja/kepala-sekolah/config'
import { useKinerjaApi } from 'api/kinerja/utils/api'

import type { KinerjaTipe, MultiPeriodParams } from 'types/kinerja'
import type {
  ResponseContentKinerjaByPsAndDinas,
  ResponseKinerjaKsByPs,
  ResponseAllPerencanaanKsByDinas,
  PerencanaanKsByDinasState,
  PerencanaanKsByDinasRole,
  PerencanaanKsByDinasTipe,
} from 'types/kinerja-ks'
import type { UseQueryOptions } from 'react-query'

export const API_GET_KS_PERENCANAAN_BY_DINAS_QUERY_KEY =
  'API_GET_KS_PERENCANAAN_BY_DINAS_QUERY_KEY'

export const API_GET_KS_CONTENT_KINERJA_BY_DINAS_QUERY_KEY =
  'API_GET_KS_CONTENT_KINERJA_BY_DINAS_QUERY_KEY'

export const API_GET_KS_PENDING_PERENCANAAN_BY_DINAS_QUERY_KEY =
  'API_GET_KS_PENDING_PERENCANAAN_BY_DINAS_QUERY_KEY'

export function useApiGetPerencanaanDinas(
  npsn: string,
  opts?: UseQueryOptions<ResponseKinerjaKsByPs>
) {
  return useKinerjaApi<ResponseKinerjaKsByPs>(apiPaths.perencanaanDinas, {
    axiosConfig: {
      params: {
        npsn,
      },
    },
    queryConfig: {
      useErrorBoundary: false,
      ...opts,
    },
    queryKey: queryKeyWithNpsn(API_GET_KS_PERENCANAAN_BY_DINAS_QUERY_KEY, npsn),
  })
}

export function useApiGetContentKinerjaDinas({
  npsn,
  tipe,
  ...opts
}: UseQueryOptions<ResponseContentKinerjaByPsAndDinas> & {
  npsn: string
  tipe?: KinerjaTipe
  override?: MultiPeriodParams
}) {
  return useKinerjaApi<ResponseContentKinerjaByPsAndDinas>(
    `${apiPaths.kontenDinas}/kinerja`,
    {
      axiosConfig: {
        params: {
          npsn,
          tipe,
          ...opts?.override,
        },
      },
      queryConfig: {
        useErrorBoundary: false,
        ...opts,
      },
      queryKey: queryKeyWithNpsn(
        API_GET_KS_CONTENT_KINERJA_BY_DINAS_QUERY_KEY,
        npsn
      ),
    }
  )
}

export function useApiGetAllPerencanaanDinas(
  {
    state,
    role,
    tipe,
  }: {
    state?: PerencanaanKsByDinasState
    role?: PerencanaanKsByDinasRole
    tipe?: PerencanaanKsByDinasTipe
  },
  opts?: UseQueryOptions<ResponseAllPerencanaanKsByDinas>
) {
  return useKinerjaApi<ResponseAllPerencanaanKsByDinas>(
    `${apiPaths.perencanaanDinas}/all`,
    {
      axiosConfig: {
        params: {
          state,
          role,
          tipe,
        },
      },
      queryConfig: {
        useErrorBoundary: false,
        ...opts,
      },
      queryKey: [
        API_GET_KS_PENDING_PERENCANAAN_BY_DINAS_QUERY_KEY,
        ...(state ? [state] : []),
        ...(role ? [role] : []),
        ...(tipe ? [tipe] : []),
      ],
    }
  )
}
